import * as React from 'react';
import { cn } from '@/shared/lib/cn';
import styles from './Card.module.css';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  muted?: boolean;
  padded?: boolean;
}

/**
 * Карточка и панель — любой блок на собственной подложке: раздел с заголовком,
 * плитка списка, боковая панель настроек.
 *
 * Берётся вместо своего `.card` в локальном css (закон 6). Ручная заготовка
 * расходится с соседними экранами по теням и радиусам; здесь они заданы
 * токенами один раз — `--surface`, `--radius-lg`, `--shadow-md`.
 *
 * `padded` — стандартные отступы, `muted` — приглушённая подложка для
 * второстепенного блока. Составные части: CardHeader, CardTitle, CardBody.
 *
 * @use блок на собственной подложке: раздел с заголовком, плитка списка, боковая панель. Всегда вместо своего `.card` в локальном css (закон 6).
 */
export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, muted, padded = true, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(styles.card, muted && styles.muted, padded && styles.padded, className)}
      {...rest}
    />
  );
});

export function CardHeader({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(styles.header, className)} {...rest} />;
}

export function CardTitle({ className, ...rest }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn(styles.title, className)} {...rest} />;
}

export function CardBody({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(styles.body, className)} {...rest} />;
}
